import { Input, InputNumber, Select, Switch } from 'antd';
import { FormItemProps } from 'antd/lib';
import { OPTIONS_PROVINCES } from '../../../../lib/documents/clinic';
import { ComponentType } from 'react';
import { CRX_SUPPORT_EMAIL } from 'app/config';

export interface FormQuestion {
  component: React.ReactElement | ComponentType;
  rules?: FormItemProps['rules'];
  required?: FormItemProps['required'];
  /**
   * The label the form should use
   */
  label?: string;
  name: string | string[];
}

export const questions: FormQuestion[] = [
  {
    name: 'name',
    label: 'Clinic Name',
    component: <Input placeholder="Clinic Name" />
  },
  {
    name: 'country',
    label: 'Country',
    component: (
      <Select
        showSearch
        placeholder="Country"
        options={[
          {
            label: 'Canada',
            value: 'canada'
          },
          {
            label: 'United States of America',
            value: 'usa'
          }
        ]}
      />
    ),
    rules: [
      {
        type: 'enum',
        required: true,
        enum: ['canada', 'usa'],
        message: `Please select a country. If your country is not listed please email ${CRX_SUPPORT_EMAIL}`
      }
    ]
  },
  {
    name: 'provinceOrState',
    label: 'Province or State',
    component: (
      <Select
        showSearch
        placeholder="Province/State"
        options={OPTIONS_PROVINCES}
      />
    ),
    rules: [
      {
        type: 'enum',
        required: true,
        enum: OPTIONS_PROVINCES.map(_ => _.value),
        message: `Please select your province or state. If your location is not listed please email ${CRX_SUPPORT_EMAIL}`
      }
    ]
  },
  {
    name: 'city',
    label: 'City',
    component: <Input placeholder="City" />,
    rules: [
      {
        type: 'string',
        required: true,
        message: `Please enter your city`
      }
    ]
  },
  {
    name: 'address',
    label: 'Address',
    component: <Input placeholder="Address" />,
    rules: [
      {
        type: 'string',
        required: true,
        message: 'Please enter the remainder of your clinic address'
      }
    ]
  },
  {
    name: 'postalOrZipCode',
    label: 'Postal or Zip code',
    component: <Input placeholder={'Postal/Zip Code'} />,
    rules: [
      {
        type: 'string',
        required: true,
        message: 'Please enter your clinics postal code'
      },
      {
        pattern:
          /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
        message: 'The postal code is invalid'
      },
      {
        transform: (val: string) => val.toUpperCase().replace(/[ -]/, '')
      }
    ]
  },
  {
    name: 'phoneNumber',
    label: 'Phone number',
    component: <Input placeholder="Phone Number" />,
    rules: [
      {
        type: 'string',
        required: true,
        message: 'Please enter your clinics phone number'
      }
    ]
  },
  {
    name: 'faxNumber',
    label: 'Fax number',
    component: <Input placeholder="Fax Number" />,
    rules: [
      {
        type: 'string',
        message: 'Please enter your clinics fax number if you have one'
      }
    ]
  },
  {
    label: 'Allow in-app purchases of Assessments',
    name: ['paymentConfig', 'assessment', 'enabled'],
    rules: [
      {
        type: 'boolean',
        required: true
      }
    ],
    component: <Switch />
  },
  {
    label: 'Assessment price',
    name: ['paymentConfig', 'assessment', 'amount'],
    rules: [
      {
        type: 'number',
        required: true
      }
    ],
    component: <InputNumber />
  },
  {
    label: 'Assessment currency (CAD, USD)',
    name: ['paymentConfig', 'assessment', 'currency'],
    rules: [
      {
        required: true,
        type: 'enum',
        enum: ['CAD', 'USD']
      }
    ],
    component: (
      <Select
        showSearch
        placeholder="Currency"
        options={[
          {
            label: 'CAD',
            value: 'CAD'
          },
          {
            label: 'USD',
            value: 'USD'
          }
        ]}
      />
    )
  },
  {
    label: 'Assessment order note',
    name: ['paymentConfig', 'assessment', 'description'],
    rules: [
      {
        type: 'string',
        required: false
      }
    ],
    component: <Input.TextArea />
  },
  {
    label: `Show 'Activate assessment in clinic' on the test-taker Home page`,
    name: ['crx_settings', 'patientHome', 'shouldShowClinicAdminText'],
    rules: [
      {
        required: false
      }
    ],
    component: <Switch />
  }
];

export const QUESTIONS_CLINIC_EDIT = questions.filter(
  q =>
    !Array.isArray(q.name) ||
    (Array.isArray(q.name) && q.name[0] !== 'paymentConfig')
);

export const QUESTIONS_CLINIC_EDIT_PAYMENTCONFIG = questions.filter(
  q => Array.isArray(q.name) && q.name[0] === 'paymentConfig'
);
